import { useEffect, useRef } from "react";
import { trackPageView } from "./api";

// Pop-out panels (Account / Owner Tools) count as their own pages, e.g. /account/preferences.
export function usePanelView(path) {
    const cur = useRef({ path: null, t: 0 });
    useEffect(() => {
        const prev = cur.current;
        if (prev.path) trackPageView(prev.path, (Date.now() - prev.t) / 1000, false);
        cur.current = { path, t: Date.now() };
        if (path) trackPageView(path, 0, true);
    }, [path]);
}
